<script setup lang="ts">
import { ref, watch, toRefs, computed } from 'vue';
import type { PropType } from 'vue';
const emit = defineEmits(['update:modelValue', 'change']);

interface List {
  id: number;
  label: string;
  icon?: string;
  iconColor?: string;
  disabled?: boolean;
}

const props = defineProps({
  modelValue: Number,
  placeholder: { type: String, default: '请输入内容' },
  class: { type: String, default: '' },
  fontsize: { type: Number, default: 16 },
  list: { type: Array as PropType<List[]>, default: () => [] },
  spacing: { type: Number, default: 22 },
  disabled: { type: Boolean, default: false },
});

const { placeholder, fontsize, list, spacing, disabled } = toRefs(props);

const className = ref(props.class);

const currentValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

const chooseItem = (id: number) => {
  if (!disabled.value && props.modelValue !== id) {
    currentValue.value = id;
    emit('change', id);
  }
};
</script>

<template>
  <div :class="className" class="fr-ac">
    <div
      class="pointer"
      :class="disabled ? 'opa4' : ''"
      :style="{ marginRight: spacing + 'px' }"
      @click="chooseItem(item.id)"
      v-for="(item, index) in list"
      :key="index"
    >
      <div class="fr-ac">
        <div
          class="fr-ac-jc select-box mr-8"
          :class="{ 'select-box-active': currentValue === item.id }"
        >
          <IconFont
            v-if="currentValue === item.id"
            name="icon_dagou"
            :size="12"
            color="#FFFFFF"
          />
        </div>
        <IconFont
          class="mr-2 mt-2"
          v-if="item.icon"
          :name="item.icon"
          :size="14"
          :color="item.iconColor"
        />
        <div
          class="fs-16 color-white"
          :style="{ 'font-size': fontsize + 'px' }"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.select-box {
  width: 18px;
  height: 18px;
  background: rgba(55, 133, 255, 0.3);
  border-radius: var(--border-radius);
  border: 1px solid var(--border-color);
}

.select-box-active {
  background: #3785ff;
  border: 1px solid #3785ff;
}
</style>
